import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import EventsStore from '../../../Stores/EventsStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import UserStore from '../../../Stores/UserStore'
import { Questionnaire, prepareQuestionnaire } from '../../../Model/Questionnaire'
import QuestionnaireForm from '../../PartialViews/Questionnaire/QuestionnaireForm'
import { toJS } from 'mobx'
import QuestionnaireDetailsView from '../../PartialViews/Questionnaire/QuestionnaireDetailsView'
import TroubleEventDetailView from '../../PartialViews/TroubleEvent/TroubleEventDetailView'
import QuestionnaireEventHistoryItemView from '../../PartialViews/Questionnaire/QuestionnaireEventHistoryView'

export interface ITroubleEventPageProps {
    httpActionsService: HttpActionsService
    eventsStore: EventsStore
    match?: object
    userStore?: UserStore
}

@inject('httpActionsService')
@inject('eventsStore')
@inject('userStore')
@observer
class TroubleEventPage extends React.Component<ITroubleEventPageProps> {

    constructor(props: any) {
        super(props)
        const teId = this.props['match']!['params']['id']
        this.props.httpActionsService.getEvent(teId)
        // this.props.httpActionsService.getPaymentsByTroubleEventId(teId)
    }

    // item: TroubleEvent

    // questionnaire: Questionnaire

    // changeStatus(e: any, status: TroubleEventStatus) {
    //     e.preventDefault()
    //     this.props.httpActionsService.changeTroubleEventStatus(this.item.id, status)
    // }

    checkCanSave() {
        const { userStore } = this.props

        return userStore!.checkAdmin
            || userStore!.checkCollectionGroupAdministrator
            || userStore!.checkCollector
            || userStore!.checkCaller
            || userStore!.checkHardCaller
            || userStore!.checkSuperAdmin
    }

    getQuestionnaireView(questionnaire: Questionnaire) {

        let q = prepareQuestionnaire(toJS(questionnaire))!

        if (!q) {
            return null
        }

        return (
            <div className="row troubleEventForm">
                <div className="troubleEventQuestionnarie  col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <QuestionnaireForm
                        className={''}
                        questionnaire={q}
                        creditDetails={true}
                        hideClone={true}
                        hideSave={!this.checkCanSave()}
                        hideCheck={true}
                    />
                </div>

                <QuestionnaireDetailsView
                    questionnaire={q}
                    className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 blockCommentsWithStatus"
                />
            </div>
        )
    }

    render() {
        const { eventsStore } = this.props

        if (!eventsStore.getItem) {
            return null
        }

        return (
            <div className="trouble-event">

                <TroubleEventDetailView item={eventsStore.getItem} />

                <QuestionnaireEventHistoryItemView
                    history={eventsStore.getItem.historyItems}
                />

                {this.getQuestionnaireView(eventsStore.getItem.questionnaire)}

            </div>
        )
    }
}

export default withRouter(TroubleEventPage) 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/TroubleEvent/TroubleEventPage.tsx